<div id="list-item-3" class="quotesContainer">
    <div class="quoteContainer1" data-aos="fade-right">
        <div class="text">
            <p class="quote">
                " أشعر بعد إنضمامي للبرنامج بأنني جزء من مجتمع أنتمي إليه."
            </p>
            <p class="person">
                آندرو هو من الأشخاص ذوي الاحتياجات الخاصة الّذين عانوا في إيجاد مكان بيئة حاضنة. وقد وجد آندرو الاطمئنان
                والراحة ضمن ال"IDEAL Program-NDU" وهو برنامج يراعي ويدعم الأطفال من ذوي الاحتياجات الخاصة على المستوى
                الأكاديمي
                تحت إشراف مؤسسّة "SKILD".
            </p>
        </div>
    </div>

    <div class="quoteContainer2" data-aos="zoom-in">
        <div class="text">
            <p class="quote">
                "أحاول دائمًا تقديم الأفضل لطفلي في هذا العالَم المليء بالظلم."
            </p>
            <p class="person">
                واجهت .B.K، أم لطفلة من ذوي الاحتياجات الخاصة العديد من العوائق في ظلّ تراكم الأزمات، صعّبت عليها
                المساهمة في دعم تطور ابنتها، خصوصًا في ظل ضغف الموارد ودعم الدولة.
            </p>
        </div>
    </div>

    <div class="quoteContainer1" data-aos="fade-up-left">
        <div class="text">
            <p class="quote">
                "لقد كان الله دومًا بجانب ابنتي طوال حياتها."
            </p>
            <p class="person">
                على الرغم من تفاقم المشاكل في السنوات الأخيرة، تحاول دائمًا .J.G، أم لطفلة من ذوي الاحتياجات الخاصة
                البحث
                عن الضوء في ظلّ العتمة. وهي تتحلى بالصبر ولا تفقد الأمل أبدا".
            </p>
        </div>
    </div>

    <div class="quoteContainer2" data-aos="zoom-out-down">
        <div class="text">
            <p class="quote">
                "كنا نحن والأهل السند لبعضنا البعض لهدف واحد وهو مساعدة الأطفال وسط كل الأزمات التي مررنا بها."
            </p>
            <p class="person">
                رأت معالجة النطق، نانسي شبيب أنّ الاختصاصيين والأهالي ساعدوا بعضهم البعض لتخطي العواقب الناجمة عن جائحة
                كورونا والأزمة الاقتصادية الّتي أثرت بشكل كبير على مسار العلاج الحاسم لتقدم الأطفال من ذوي الاحتياجات.
            </p>
            <div class="audio_">
                <audio id="player" controls>
                    <source src="../assets/audio/Nancy Chebib (معالجة النطق).mpeg" type="audio/mpeg">
                </audio>
            </div>
        </div>
    </div>

    <div class="quoteContainer1" data-aos="fade-down">
        <div class="text">
            <p class="quote">
                "يجب على الطفل أن يدرك أن ما يشعر به هو نتيجة أسباب خارجية. كما يجب عليه أن يعبّر عن نفسه باستمرار وأن
                يشعر بالحرية في إاصال أفكاره وعواطفه لكي تتحسن حالته."
            </p>
            <p class="person">
                إعتبرت المعالجة الحركية، هالة معلوف أنّ هذه الشريحة هي من أكثر الفئات المتضررة جرّاء الأزمات في لبنان.
                وغالبًا ما يجد الطفل نفسه مليء بمشاعر من الصعب التعبير عنها.
            </p>
            <div class="audio_">
                <audio id="player" controls>
                    <source src="../assets/audio/Hala Maalouf (المعالجة الحركية).mpeg" type="audio/mpeg">
                </audio>
            </div>
        </div>
    </div>

</div>